import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'
import { client } from '@/proxy/client'

export const SELLER_PERMISSIONS = gql`
  query sellerPermissions($skip: Boolean!) {
    seller @skip(if: $skip) {
      permissions {
        hasOnlinePaymentSection
      }
    }
  }
`

export const SELLER_PERMISSIONS_KEY = 'useSellerPermissions'

export const useSellerPermissions = (variables, options) =>
  useQuery({
    queryKey: [SELLER_PERMISSIONS_KEY, variables],
    queryFn: () => client.request(SELLER_PERMISSIONS, variables),
    ...options,
  })
